import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import BlockUi from 'react-block-ui';
import { Helmet } from 'react-helmet';
import GuestBox from '../../components/GuestBox';
import Link from '../../components/Link';
import ButtonField from '../../components/ButtonField';
import TextField from '../../components/LogingTextField';
import logo from '../../assets/vb-logo.png';
import {
  createLoadingSelector,
  createErrorMessageSelector,
} from '../Main/reducer';
import { FORGOT_PASSWORD_REQUEST, forgotPasswordRequest } from './actions';
import { emailValidator } from '../../utils/validator';

class ForgotPasswordPage extends React.Component {
  handleFormSubmit = (values) => {
    this.props.forgotPasswordRequest(values);
  };

  render() {
    const { history, handleSubmit, loading, error } = this.props;
    return (
      <BlockUi blocking={loading}>
        <Helmet>
          <title>Forgot Password | VoiceboxMD Web</title>
          <meta
            name="description"
            content="Reset your password to continue using VoiceboxMD."
          />
        </Helmet>
        <GuestBox>
          <img
            src="./favicon.ico"
            alt="VoiceboxMD Logo"
            style={{ width: '25px', marginBottom: '1rem' }}
          />
          <img
            src={logo}
            alt="VoiceboxMD Logo"
            style={{ width: '150px', marginBottom: '1rem' }}
          />
          <div className="title mb-4">
            <FormattedMessage
              id="ForgotPage.title"
              defaultMessage="Forgot Password"
            />
          </div>
          {error && (
            <div className="text-danger mb-3">
              <FormattedMessage
                id="ForgotPage.error"
                defaultMessage={error || 'An error occurred. Please try again.'}
              />
            </div>
          )}
          <FormattedMessage
            id="ForgotPasswordPage.email"
            defaultMessage="Email Address"
          >
            {(msg) => (
              <Field
                name="email"
                component={TextField}
                placeholder={msg}
                className="mb-4"
                type="email"
              />
            )}
          </FormattedMessage>
          <ButtonField
            className="mb-3"
            onClick={handleSubmit(this.handleFormSubmit)}
            disabled={loading}
          >
            <FormattedMessage id="ForgotPage.next" defaultMessage="Next" />
          </ButtonField>
          <Link bold onClick={() => history.push('/login')} className="forgot">
            <FormattedMessage
              id="ForgotPage.return"
              defaultMessage="Return to Login"
            />
          </Link>
        </GuestBox>
      </BlockUi>
    );
  }
}

ForgotPasswordPage = reduxForm({
  form: 'forgot',
  validate: (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = 'required';
    } else if (!emailValidator(values.email)) {
      errors.email = 'invalidEmail';
    }
    return errors;
  },
})(ForgotPasswordPage);

ForgotPasswordPage = connect(
  createStructuredSelector({
    loading: createLoadingSelector([FORGOT_PASSWORD_REQUEST]),
    error: createErrorMessageSelector([FORGOT_PASSWORD_REQUEST]),
  }),
  { forgotPasswordRequest }
)(ForgotPasswordPage);

export default ForgotPasswordPage;
